import Vue from 'vue'
import {
  // RESET_STATE,
  INIT
} from './mutation-types'

let initialState = {
  isInitiated: false
}

// initial state
const state = Vue.util.extend({}, initialState)

// getters
const getters = {
  isInitiated: function (state) {
    return state.isInitiated
  }
}

// actions
const actions = {
  initializeData: function ({commit, dispatch, state}) {
    return new Promise((resolve, reject) => {
      commit('INIT')
      resolve()
    })
  }
}

// mutations
const mutations = {
  // [RESET_STATE]: function (state) {
  //   for (let f in state) {
  //     Vue.set(state, f, initialState[f])
  //   }
  // },
  [INIT]: function (state) {
    state.isInitiated = true
  }
}

export default {
  state,
  actions,
  getters,
  mutations
}



// WEBPACK FOOTER //
// ./src/store/rootModule.js